import styled from '@emotion/styled';

const Spacer = styled.div`
  width: ${({ width }) => width};
`;

export default {
  Spacer,
};
